var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{class:{
            'bg-warning': _vm.isOld(),
            'label': _vm.isOld(),
            'text-white': _vm.isOld(),
        },staticStyle:{"padding":"3px"}},[_vm._v("\n        "+_vm._s(_vm.relativeTime)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }